<div class="custom-dialog">
  <div class="lock-container">
    <span class="lock-icon">🔒</span>
  </div>
  <h2 class="title">Access Temporarily Locked</h2>
  <p class="message">
    Due to multiple failed attempts, your account is temporarily locked.
  </p>
  <p class="countdown-text">
    <strong>Please wait {{ remainingTime }} seconds before trying again.</strong>
  </p>

  <button class="close-btn" (click)="onClose()" [disabled]="remainingTime > 0">
    Got It
  </button>
</div>

